module.exports = __webpack_public_path__ + "static/media/icon_avulso.1a5d1915.svg";